import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import LoginWrapper from './LoginWrapper';
import Button from '../common/Button';
import Input from '../common/Input';
import { receiveLoginToken } from './duck';
import i18n from '../core/i18n';
import * as API from '../core/api';

class LoginScreen extends React.Component {
  state = {
    password: '',
    passwordRepeat: '',
    isLoading: false,
    redirectToHome: false,
  };

  componentDidMount() {
    const { lang, teamName } = this.props;

    if (lang) {
      i18n.changeLanguage(lang);
      document.title = i18n.t('docTitle', { name: teamName });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { token } = this.props.match.params;
    const { password, passwordRepeat } = this.state;
    const { t } = this.props;

    if (password !== passwordRepeat) {
      return alert(t('auth.errPasswordsNotMatching'));
    }

    this.setState({ isLoading: true });

    return API.post('auth/pass-change', { token, password })
      .then((res) => {
        this.props.receiveLoginToken(res);
        this.setState({ redirectToHome: true });
      })
      .catch((err) => alert(JSON.stringify(err)))
      .finally(() => this.setState({ isLoading: false }));
  };

  render() {
    const { error, t } = this.props;
    const { isLoading, redirectToHome } = this.state;

    if (redirectToHome) {
      return <Redirect to={{ pathname: '/home' }} />;
    }

    return (
      <LoginWrapper>
        <div className="c-login__form-container">
          <form
            onSubmit={this.handleSubmit}
            className="o-box o-box--huge c-box c-box--outlined u-text-center u-margin-bottom"
            style={{ width: '330px' }}
          >
            <Input
              type="password"
              placeholder={t('auth.newPass')}
              onChange={(e) => this.setState({ password: e.target.value })}
            />

            <Input
              type="password"
              placeholder={t('auth.repeatPass')}
              onChange={(e) =>
                this.setState({ passwordRepeat: e.target.value })
              }
            />

            <Button
              className="u-margin-top-tiny"
              type="submit"
              disabled={isLoading}
              size="small"
            >
              {isLoading ? t('general.loading') : t('auth.newPassSubmit')}
            </Button>

            {error && (
              <p className="c-alert c-alert--danger u-margin-top">{error}</p>
            )}
          </form>
        </div>
      </LoginWrapper>
    );
  }
}

const mapDispatchToProps = { receiveLoginToken };
const mapStateToProps = ({ auth, workspace }) => ({
  lang: workspace.data && workspace.data.lang,
  teamName: workspace.data && workspace.data.name,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(translate()(LoginScreen))
);



// WEBPACK FOOTER //
// ./src/auth/ChangePassScreen.js